import { registerPlugin } from '@capacitor/core';

export interface FacebookAnalyticsPlugin {
  logPurchase(options: { amount: number; currency: string }): Promise<void>;
}

const FacebookAnalytics = registerPlugin<FacebookAnalyticsPlugin>('FacebookAnalytics');

export default FacebookAnalytics; 